import React from 'react';
import {
  bool, func, node, string,
} from 'prop-types';

const ButtonWrapper = ({
  children,
  isVisible = true,
  loadMenuData,
  onMouseLeave = () => {},
  onMouseMove = () => {},
  showDrawer,
  toggleKey,
}) => isVisible && (
  // Uses a div instead of AntD Button to avoid antd styling overrides
  // that conflict with the custom toggle-btn appearance. Accessibility
  // is preserved via role, tabIndex, and keyboard event handlers.
  <div
    className="top-menu-field-groups__toggle-btn"
    role="button"
    tabIndex={0}
    onClick={() => showDrawer(toggleKey)}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        showDrawer(toggleKey);
      }
    }}
    onMouseOver={loadMenuData}
    onFocus={loadMenuData}
    onMouseMove={onMouseMove}
    onMouseLeave={onMouseLeave}
  >
    {children}
  </div>
);

ButtonWrapper.propTypes = {
  children: node.isRequired,
  isVisible: bool,
  loadMenuData: func.isRequired,
  onMouseLeave: func,
  onMouseMove: func,
  showDrawer: func.isRequired,
  toggleKey: string.isRequired,
};

export default ButtonWrapper;
